import { render, staticRenderFns } from "./CompensatoryLeavesEmployeeList.vue?vue&type=template&id=6f6135c8"
import script from "./CompensatoryLeavesEmployeeList.vue?vue&type=script&lang=js"
export * from "./CompensatoryLeavesEmployeeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports